import { Controller } from '@hotwired/stimulus';

// 退会理由のチェックに応じて、補足の入力欄と案内パネルを出し分ける。
// 案内は利用者が自ら選んだ理由のときだけ出す(全員には出さない)。
export default class extends Controller {
  static targets = ["otherAppName", "setupMistake", "wrongAccount"]

  connect() {
    this.refresh()
  }

  refresh() {
    this.toggle(this.otherAppNameTargets, "other_app")
    this.toggle(this.setupMistakeTargets, "setup_mistake")
    this.toggle(this.wrongAccountTargets, "wrong_account")
  }

  toggle(targets, reason) {
    const checkbox = this.element.querySelector(`#resign_reasons_${reason}`)
    const checked = Boolean(checkbox && checkbox.checked)
    targets.forEach((target) => { target.hidden = !checked })
  }
}
